<template>
  <div class="new w-main">
    <div class="he30"></div>
    <div class="new-nav">
      <span
        :class="{ act: item.id === ActTypeID }"
        v-for="(item, index) in tabNav"
        :key="index"
        @click="TabClick(item)"
        >{{ item.name }}</span
      >
    </div>
    <div class="he50"></div>
    <div class="new-box">
      <div class="new-boxItem" v-for="(item, index) in newList" :key="index">
        <router-link
          class="main"
          :to="{
            path: '/new/details',
            query: { title: tabName, id: item.id }
          }"
          tag="div"
        >
          <div class="boxItemIme">
            <el-image :src="item.cover" fit="fill"></el-image>
          </div>
          <div class="new-boxItemTitle">{{ item.title }}</div>
          <div class="new-boxItemText">{{ item.subtitle }}</div>
        </router-link>
      </div>
    </div>
    <router-link to="/new" target="_blank" tag="a" class="home-button">
      <span>了解更多</span>
      <span>></span>
    </router-link>
  </div>
</template>

<script>
import { getNewsCategoryList, getNewsList } from "@/api/api.js";

export default {
  name: "pcHomeVipLink",
  data() {
    return {
      tabNav: [],
      ActTypeID: "",
      newList: [],
      tabName: ""
    };
  },
  mounted() {
    this.getNewsCategoryList();
  },
  methods: {
    getNewsCategoryList() {
      getNewsCategoryList().then(res => {
        if (res.code === 0) {
          this.tabNav = res.data;
          this.ActTypeID = this.tabNav[0].id;
          this.tabName = this.tabNav[0].name;
          this.getNewsList();
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    getNewsList() {
      getNewsList(this.ActTypeID).then(res => {
        if (res.code === 0) {
          this.newList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    TabClick(item) {
      this.ActTypeID = item.id;
      this.tabName = item.name;
      this.getNewsList();
    }
  }
};
</script>

<style lang="less">
.new {
  // flex-flow: wrap;
  .new-nav {
    display: flex;
    justify-content: center;
    span {
      display: inline-block;
      margin: 0 20px;
      width: 108px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 2px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      cursor: pointer;
    }
    .act {
      background: rgba(107, 43, 101, 1);
      color: #fff;
    }
  }
  .new-box {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-bottom: 40px;
    .new-boxItem {
      width: 33.33%;
      margin-bottom: 20px;
    }
    .main {
      margin: 0 auto;
      width: 300px;
      cursor: pointer;
    }
    .new-boxItemTitle {
      margin-top: 16px;
      font-size: 20px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      line-height: 24px;
    }
    .new-boxItemText {
      margin-top: 6px;
      font-size: 16px;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
  .home-button {
    margin: 50px auto 0;
  }
}
</style>
